/** Enough for a 5-minute run of ~6–10s clips (~50 scenes). */
export const MAX_PROJECT_CLIPS = 60;
export const MIN_STITCH_CLIPS = 2;
export const MAX_STITCH_DURATION_SEC = 300;
export const PROJECT_STORAGE_KEY = "video-studio-project-clips";

export const OUTPUT_RESOLUTIONS = [
  { id: "source", labelKey: "videoProjectResSource", fallback: "Match clips (fastest)" },
  { id: "480p", labelKey: "videoProjectRes480", fallback: "480p" },
  { id: "720p", labelKey: "videoProjectRes720", fallback: "720p" },
  { id: "1080p", labelKey: "videoProjectRes1080", fallback: "1080p" },
];
